import { SectionField } from "types/Models/Filing";
import { emptyApi } from "./emptyApi";

export type IRSField = SectionField & { editable: boolean };

export type IRSSection = {
  title: string;
  fields: IRSField[];
};

export type IRSDetailsResponse = {
  sections: IRSSection[];
};

export const IRS_SUBMISSION_STATUSES = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
} as const;

export type IRSSubmissionStatus = {
  status: (typeof IRS_SUBMISSION_STATUSES)[keyof typeof IRS_SUBMISSION_STATUSES];
  submitted_at: string | null;
};

export type SubmitToIRSPayload = {
  taskId: string;
  sections: IRSSection[];
};

export const irsDetailsApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getIRSFieldDetails: build.query<IRSDetailsResponse, { taskId: string }>({
      query: ({ taskId }) => `api/inkle/tasks/${taskId}/irs-details/`,
      providesTags: (_, __, { taskId }) => [
        { type: "IRS_DETAILS", id: taskId },
      ],
    }),

    getIRSSubmissionStatus: build.query<
      IRSSubmissionStatus,
      { taskId: string }
    >({
      query: ({ taskId }) => `api/inkle/tasks/${taskId}/irs-submission-status/`,
      providesTags: (_, __, { taskId }) => [
        { type: "IRS_SUBMISSION_STATUS", id: taskId },
      ],
    }),

    submitToIRS: build.mutation<void, SubmitToIRSPayload>({
      query: ({ taskId, sections }) => ({
        url: `api/inkle/tasks/${taskId}/submit-to-irs/`,
        method: "POST",
        body: { sections },
      }),
      invalidatesTags: (_, __, { taskId }) => [
        { type: "IRS_SUBMISSION_STATUS", id: taskId },
      ],
    }),
  }),
});

export const {
  useGetIRSFieldDetailsQuery,
  useGetIRSSubmissionStatusQuery,
  useSubmitToIRSMutation,
} = irsDetailsApi;
